import { FaUserCheck, FaUserTimes, FaUserClock } from "react-icons/fa";
import { MdOutlineHolidayVillage } from "react-icons/md";
import AttendenceTabs from "./AttendenceTabs";
import { GoArrowLeft } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const stats = [
  {
    title: "Present Today",
    value: 5,
    sub: "Out of 8 staff members",
    icon: <FaUserCheck className="text-green-600 text-3xl" />,
    progress: "w-3/4",
    color: "bg-green-500",
    change: "+2%",
    bg: "from-green-100 to-green-50",
    circle: "bg-green-200",
  },
  {
    title: "Absent Today",
    value: 1,
    sub: "Unplanned absences",
    icon: <FaUserTimes className="text-red-600 text-3xl" />,
    progress: "w-1/4",
    color: "bg-red-500",
    change: "-1%",
    bg: "from-red-100 to-red-50",
    circle: "bg-red-200",
  },
  {
    title: "On Leave",
    value: 1,
    sub: "Approved leave requests",
    icon: <MdOutlineHolidayVillage className="text-blue-600 text-3xl" />,
    progress: "w-1/4",
    color: "bg-blue-500",
    change: "0%",
    bg: "from-blue-100 to-blue-50",
    circle: "bg-blue-200",
  },
  {
    title: "Late Arrivals",
    value: 1,
    sub: "More than 30 minutes late",
    icon: <FaUserClock className="text-yellow-600 text-3xl" />,
    progress: "w-1/4",
    color: "bg-yellow-500",
    change: "-3%",
    bg: "from-yellow-100 to-yellow-50",
    circle: "bg-yellow-200",
  },
];

export default function StaffAttendance() {
    const navigate=useNavigate();
  return (
    <div className="p-6">
        <div className="mb-3 flex items-center gap-2">
        <button
                  className="bg-white inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium border border-gray-300 hover:bg-gray-100 p-2"
                  onClick={()=>navigate(-1)}
                  type="button"
                >
                  <GoArrowLeft />
                  <span className="sr-only">Back</span>
                </button>      
      <h2 className="text-2xl font-bold">Staff Attendance</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((item, idx) => (
          <div
            key={idx}
            className={`relative overflow-hidden rounded-2xl shadow-md p-4 hover:shadow-xl transition duration-300 transform hover:-translate-y-1 cursor-pointer bg-gradient-to-br ${item.bg}`}
          >
            {/* Decorative background circle */}
            <div
              className={`absolute -top-10 -right-10 w-32 h-32 rounded-full ${item.circle} opacity-40`}
            ></div>

            <div className="relative z-10">
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-semibold text-gray-800">{item.title}</h3>
                {item.icon}
              </div>
              <p className="text-3xl font-bold">{item.value}</p>
              <div className="w-full bg-gray-200 rounded-full h-2 mt-3">
                <div
                  className={`${item.color} h-2 rounded-full ${item.progress}`}
                ></div>
              </div>
              <div className="flex justify-between items-center mt-2 text-sm text-gray-600">
                <span>{item.sub}</span>
                <span
                  className={`font-semibold ${
                    item.change.startsWith("-")
                      ? "text-red-500"
                      : "text-green-600"
                  }`}
                >
                  {item.change}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="col-12 border-1 rounded-lg bg-white mt-4 p-2">
          <AttendenceTabs />
        </div>
    </div>
  );
}
